export default __webpack_public_path__ + "static/media/sad_female.22b105b9.png";